__webpack_require__.p = "/strategy/";